import React, { useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { balEmployeeLookup, employeeFetchPage, employeePageUpdate } from '../../redux/employeeReducer';

import EmployeeFilter from './EmployeeFilter';
import EmployeeList from './EmployeeList';
import Pagination from '../Pagination';

const useStyles = makeStyles({
    title: {
        paddingBottom: "15px",
        fontSize: "26px",
        lineHeight: "26px",
        fontWeight: "bold",
    },
});


export default function Employee() {
    const classes = useStyles();

    const history = useHistory();

    const dispatch = useDispatch();

    const { hasFilter } = useParams();

    const newEmployee = () => {
        history.push("/employeeDetail/new");
    }

    const { filter } = useSelector(state => {
        return state.employee;
    });

    const { jWTClaimModel: { Creds } } = useSelector(state => {
        return state.auth;
    });

    useEffect(() => {
        if (!Creds.includes("COMMISSION")) history.replace("/");

        dispatch(balEmployeeLookup(hasFilter ? filter : null));
    }, []);

    return (
        <>
            <Typography variant="h1" className={classes.title}>2. 員工資料</Typography>
            <Grid container justifyContent="space-between" className="mb-2">
                <Grid item>
                    <Button variant="contained" size="small" onClick={newEmployee}>新增員工資料</Button>
                </Grid>
            </Grid>
            <EmployeeFilter filter={filter} />
            <Pagination filter={filter} fnFetchPage={employeeFetchPage} fnPageUpdate={employeePageUpdate} />
            <EmployeeList />
            <div style={{ margin: "5px", textAlign: 'center' }}>
                <Pagination filter={filter} fnFetchPage={employeeFetchPage} fnPageUpdate={employeePageUpdate} />
            </div>
        </>
    );
}
